/**
 * Display helpers for CMM order notes sidebar (timestamps and limits).
 */
import { formatRelativeTime } from "./formatRelativeTime";

/** Maximum characters allowed in a single note body. */
export const MAX_CMM_NOTE_CHARS = 500;

/**
 * Parses an ISO or other timestamp string for relative display.
 *
 * @param value - Stored `timestamp` field from Firestore.
 * @returns A `Date` when parseable, otherwise `null`.
 */
export function parseNoteTimestamp(value: string): Date | null {
  const ms = Date.parse(value);
  if (Number.isNaN(ms)) return null;
  return new Date(ms);
}

/**
 * Returns a short relative label for a note, or the raw string if parsing fails.
 *
 * @param timestamp - ISO (or other) timestamp string from the note document.
 * @param now - Reference instant for relative wording.
 * @returns Text suitable for the note card header.
 */
export function getNoteTimestampLabel(timestamp: string, now: Date): string {
  const parsed = parseNoteTimestamp(timestamp);
  return parsed ? formatRelativeTime(parsed, now) : timestamp;
}
